export const OFFER_RESOURCE_IMPROVEMENTS_TOGGLE = 'EnableOfferResourceImprovements';
